import { baseApi } from 'services'

export const documentsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    createEnvelope: builder.mutation<any, any>({
      query: (val) => {
        return {
          url: 'v2/docusign/',
          method: 'POST',
          body: val,
        }
      },
    }),
  }),
})

export const { useCreateEnvelopeMutation } = documentsApi
